<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
         <preLoader v-if="loader"></preLoader>
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
                <router-link to="/service/list" class="btn btn-default">{{ $t('Back') }}</router-link>
            </div>

            <CRow class="justify-content-md-center">
                <CCol sm="6">
                    <CCard>
                    <form v-on:submit.prevent="saveForm()">

                        <CCardHeader>
                            <strong> آیتم خدمت جدید </strong>
                            <!--                        <div class="card-header-actions">-->
                            <!--                            <a-->
                            <!--                                    href="#"-->
                            <!--                                    class="card-header-action"-->
                            <!--                                    rel="noreferrer noopener"-->
                            <!--                                    target="_blank"-->
                            <!--                            >-->
                            <!--                                <small class="text-muted">خروجی اکسل</small>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                        </CCardHeader>
                        <CCardBody  class="p-5">


                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Assortment') }}</label>


                                <select class="form-control" v-model='item.service_categories_id'>
                                    <option v-for="(service_category,index) in service_categories"
                                        :value="service_category.id" :key="index">
                                        <!-- here -->
                                        {{service_category.title}}
                                    </option>
                                </select>



                                <!--
                    v-on:change='getCities(selectedCountry.rid)'
                    <option  v-for="service_category of service_categories"  value="{{service_category.id}}">{{service_category.title}}</option>-->


                            </div>
                        </div>



                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">  {{ $t('Title') }}</label>
                                <input type="text" v-model="item.title" class="form-control">
                                <!--:class="{'has-error': errors[0].has('title')}"-->


                                <!--<p v-if="errors[0].has('title')" class="alert-danger">-->
                                <!--{{ errors[0].first('title') }}-->
                                <!--</p>-->

                            </div>
                        </div>


                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <label class="control-label">Code</label>
                                    <input type="text" v-model="item.coce" class="form-control">

                                </div>
                            </div>
                        <!--<div class="row">-->
                        <!--<div class="col-xs-12 form-group">-->
                        <!--<label class="control-label">تصویر</label>-->
                        <!--<input type="text" v-model="item.image" class="form-control">-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>
<!--                         <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">{{ $t('Score') }}</label>-->
<!--                                <input type="text" v-model="item.score" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Image') }} </label>
                                <div class="form-group">
                                    <div class="input-group input-file" name="Fichier1">
                                        <input type="text" class="form-control" :placeholder="placeholder" />
                                        <input type="file" class="filestyle" ref="file" @change="onFileChange($event)" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-default btn-choose" type="button">{{ $t('File') }}</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--<div class="row">-->
                            <!--<div class="col-xs-12 form-group">-->
                                <!--<label class="control-label">تعداد ارائه خدمت</label>-->
                                <!--<input type="text" v-model="item.initial_number" class="form-control">-->
                            <!--</div>-->
                        <!--</div>-->



                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> {{ $t('Default price') }}({{$curency}})</label>
                                <input class="form-control" v-model="item.price">

                            </div>
                        </div>


<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">{{ $t('Minimum time') }}({{ $t('min') }})</label>-->
<!--                                <input type="text" v-model="item.min_time" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label"> {{ $t('Maximum time') }}({{ $t('min') }})</label>-->
<!--                                <input type="text" v-model="item.max_time" class="form-control">-->
<!--                            </div>-->

<!--                        </div>-->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">{{ $t('Add') }}</button>
                            </div>
                        </div>


                        </CCardBody>
                    </form>
                    </CCard>
                </CCol>
            </CRow>
    </div>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }

    };

    export default {
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token'),
                        // headers: {
                            'Content-Type': 'multipart/form-data'
                        // }
                    }
                },
                placeholder: "...فایل را انتخاب کنید",
                
                item: {
                    code: '',
                    parent_id: '',
                    service_categories_id: '1',
                    title: '',
                    description: '',
                    initial_number: '',
                    price: '',
                    tax: 0,
                    min_time: '',
                    max_time: '',
                    image: '',
                    score: ''

                },

                errors: [],
                loader:false,
                service_categories: [],
                Object: {}

            }
        },

        mounted() {
            
            axios
                .get('/api/serviceCategorieslist', this.auth)
                .then(response => {
                    this.service_categories = response.data;

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
            this.spliceNumber("1")

        }


        ,

        methods: {
            onFileChange(e) {
               
                //    console.log(e.target.files[0])
                this.item.image = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                 console.log(this.item.image ,"144")

            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                app.loader=true
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                       console.log(key, element);
                    }
                }
                 console.log(formData,"4444")
                axios.post('/api/services', formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('آیتم با موفقیت ذخیره شد');
                        app.$router.push({
                            path: '/service/list'
                        });
                        app.loader=false
                         console.log(resp);

                    })
                    .catch(function (e) {
                        app.loader=false
                        app.errors.push(e.response.data.messages_fa);

                        //                            app.$snotify.warning(e.response.data.message);
                        console.log(e.response.data);


                        for (let value of e.response.data.messages_fa) {
                            //                        for (let error of Object.entries(value[1])) {
                            //                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value, {
                                timeout: 7000,
                                //                                    showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true
                            });

                            //                        }
                        }

                    });


            }
        }
    }

</script>
<style scoped>
    .filestyle {
        width: 100%;
        position: absolute;
        height: 100%;
        z-index: 1111;
        opacity: 0;
    }

</style>
